import { useMemo } from 'react';
import { useAuth } from '../assets/utils/useAuth';

/**
 * Encounter/claims rollout switches as resolved for this admin by the API
 * (GET /v2/users/profile → data.rollout, see ClaimsRolloutService).
 *
 * For internal staff a facility-scoped flag reads true when it is on for ANY
 * facility; the per-facility pilot allowlist is still enforced server-side on
 * every write, so the worst a stale flag can do is show a button that the API
 * then refuses.
 *
 * Empty (every switch off) on an older API, or a host that has not run
 * 20261007_claims_rollout_settings.sql — the admin portal then behaves exactly
 * as it did before the overhaul.
 *
 * @returns {{
 *   preview_allowed?: boolean,
 *   submit_separation_enabled?: boolean,
 *   auto_checkout_enabled?: boolean,
 *   item_removal_enabled?: boolean,
 *   pending_banner_enabled?: boolean,
 *   month_complete_notice_enabled?: boolean,
 *   auto_checkout_hours?: number,
 * }}
 */
export default function useClaimsRollout() {
  const { user } = useAuth();
  return useMemo(() => {
    const rollout = user?.profile?.rollout;
    return rollout && typeof rollout === 'object' ? rollout : {};
  }, [user]);
}
